import defaultState from "./state";

const DocumentReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_DOCUMENTS": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "SUCCESS_DOCUMENTS": {
      return Object.assign({}, state, {
        isSuccess: action.isSuccess,
      });
    }
    case "ERROR_DOCUMENTS": {
      return Object.assign({}, state, {
        isError: action.isError
      });
    }
    case "SET_DESCRIPTION": {
      return Object.assign({}, state, {
        description: action.description,
      });
    }
    case "VIEW_DOCUMENTOS": {
      return Object.assign({}, state, {
        viewDocumentos: action.view,
        infoDocuments: action.data,
      });
    }
    case "SET_DOCUMENT_SINIESTRO": {
      return Object.assign({}, state, {
        listDocuments: action.listDocuments,
      });
    }

    default:
      return state;
  }
};

export default DocumentReducer;
